var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M11.896 18.729a.966.966 0 0 1-1.343 0l-8.275-8.074a.91.91 0 0 1 0-1.31l8.275-8.074A.96.96 0 0 1 11.224 1c.244 0 .486.09.672.271a.91.91 0 0 1 0 1.31L4.292 10l7.604 7.418a.91.91 0 0 1 0 1.31z"
  })));
};
export default SvgArrowLeft;